import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reduceAllowEdit } from '../../actions/policy/reduceAllowEdit';
import { reduceEditScope } from '../../actions/policy/reduceEditScope';
import { reducePolicy } from '../../actions/policy/reducePolicy';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPolicySaga() {
    try {
        yield put(reduceLoading({ code: 'getPolicy', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/policyTransaction/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));

        if (!result.operation.status) {
            return;
        }

        // isReadOnly is the status-only verdict; editScope (Metrix.Policy 4.4.3+) says whether THIS
        // session may still save and which product field codes stay frozen. Without it, fall back
        // to the old rule: editable unless read-only.
        const editScope = {
            isReadOnly: result.isReadOnly === true,
            canEdit: result.editScope?.canEdit ?? result.isReadOnly !== true,
            frozenFields: result.editScope?.frozenFields ?? [],
        };

        yield put(reducePolicy(result.policyTransaction));
        yield put(reduceEditScope(editScope));
        yield put(reduceAllowEdit(editScope.canEdit));
        yield put(reduceLoading({ code: 'getPolicy', value: false }));
    } catch (error) {
        console.log('Error while calling Get Policy API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'getPolicy', value: false }));
    }
}
